
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/burn/estimate",
      function () {
        return require("private-next-pages/burn/estimate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/burn/estimate"])
      });
    }
  